import React from 'react';

const IconTwitter = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  role="img"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  className="feather feather-leetcode">
  <title>LeetCode</title>
  <path d="M20.13 3.23a1.78 1.78 0 0 0-2.45.2l-8.91 8.91c-.43.43-.43 1.13 0 1.56l8.91 8.91a1.78 1.78 0 0 0 2.45.2c.61-.61.61-1.6 0-2.22l-8.13-8.13 8.13-8.13c.61-.62.61-1.6 0-2.22zm-9.45 8.12L3.72 16.3a1.79 1.79 0 0 0 0 2.53c.69.69 1.81.69 2.5 0l6.91-6.92-2.45-2.56zM11.69 4.5a1.78 1.78 0 0 0-2.45-.2c-.61.61-.61 1.6 0 2.22l8.13 8.13-8.13 8.13c-.61.62-.61 1.6 0 2.22.69.69 1.81.69 2.5 0l9.45-9.45c.43-.43.43-1.13 0-1.56l-9.45-9.45z"></path>
</svg>

);

export default IconTwitter;
